export const translations = {
    vi: {
        controlCenter: 'Trung tâm điều khiển',
        responsiveWorkspace: 'Không gian smart-home responsive',
        ecosystemSynced: 'Hệ sinh thái đang đồng bộ',
        authRealtimeReady: 'Auth + realtime giữ nguyên',
        logout: 'Đăng xuất',
        dashboard: 'Bảng điều khiển',
        rooms: 'Phòng',
        activity: 'Hoạt động',
        connect: 'Kết nối',
        settings: 'Cài đặt',
        adminDevices: 'Quản lý thiết bị',
        language: 'Ngôn ngữ',
        vietnamese: 'Tiếng Việt',
        english: 'English',
        adminOnly: 'Chỉ admin mới dùng được mục này.',
        save: 'Lưu',
        cancel: 'Hủy',
        delete: 'Xóa',
        confirm: 'Xác nhận',
        search: 'Tìm kiếm',
        filter: 'Lọc',
        all: 'Tất cả',
        active: 'Đang hoạt động',
        archived: 'Đã lưu trữ',
        loading: 'Đang tải',
        refresh: 'Làm mới',
        networkError: 'Lỗi mạng',
        sessionExpired: 'Phiên đăng nhập đã hết hạn',
        permissionDenied: 'Bạn không có quyền thực hiện thao tác này',
        notFound: 'Không tìm thấy dữ liệu',
        importToApp: 'Import vào app',
        importSelected: 'Import đã chọn',
        linked: 'Đã liên kết',
        notLinked: 'Chưa liên kết',
        xiaomiReady: 'Thiết bị Xiaomi',
        homeAssistantSource: 'Home Assistant vẫn là source of truth',
        settingsSubtitle: 'Tuỳ biến hiển thị và ngôn ngữ cho người dùng.',
        connectSubtitle: 'Onboarding kết nối thiết bị qua Home Assistant.',
        deviceManagementSubtitle: 'Admin quản lý metadata, phân phòng và liên kết entity HA.',
        noDevicesYet: 'Chưa có thiết bị phù hợp.',
        languageSavedLocal: 'Ngôn ngữ đang được lưu trên trình duyệt hiện tại.',
        appearance: 'Giao diện',
        deviceLinking: 'Liên kết thiết bị',
        xiaomiFlow: 'Quy trình Xiaomi',
        previewReady: 'Sẵn sàng cho preview',
        roomDevices: 'Thiết bị trong phòng',
        noDevicesInRoom: 'Không có thiết bị nào trong phòng',
        editRoom: 'Sửa phòng',
        roomUpdated: 'Đã cập nhật phòng',
        newScene: 'Scene mới',
        editScene: 'Sửa scene',
        sceneActions: 'Hành động scene',
        addAction: 'Thêm action',
        removeAction: 'Xóa action',
        sceneCreated: 'Đã tạo scene',
        sceneUpdated: 'Đã cập nhật scene',
        entityId: 'Entity ID',
        actionLabel: 'Hành động',
        actionValue: 'Giá trị',
        homeMembers: 'Thành viên home',
        inviteMember: 'Mời thành viên',
        inviteByEmail: 'Mời bằng email',
        memberInvited: 'Đã mời thành viên',
        changeRole: 'Đổi vai trò',
        disableMember: 'Vô hiệu hóa thành viên',
        presenceMode: 'Chế độ hiện diện',
        home: 'Ở nhà',
        away: 'Vắng nhà',
        night: 'Ban đêm',
        vacation: 'Đi vắng dài ngày',
        activityFeed: 'Luồng hoạt động',
        noActivity: 'Chưa có hoạt động',
        stateChange: 'Thay đổi trạng thái',
        commandSent: 'Đã gửi lệnh',
        roomFocusSubtitle: 'Theo dõi thiết bị và scene theo room trong active home.',
        roomSettings: 'Thiết lập phòng',
        roomNotFound: 'Không tìm thấy phòng',
        roomNotFoundDesc: 'Kiểm tra lại đường dẫn hoặc quay lại dashboard để chọn room khác.',
        saveRoom: 'Lưu phòng',
        roomNoDevices: 'Phòng này chưa có thiết bị',
        roomNoDevicesDesc: 'Gán metadata room cho thiết bị để room page hiển thị đúng.',
        updateRoomSuccess: 'Đã cập nhật thông tin phòng.',
        updateRoomFailed: 'Không cập nhật được phòng.',
        roomScenes: 'Scene của phòng',
        noRoomScenes: 'Chưa có scene cho phòng',
        noRoomScenesDesc: 'Khi scene được map với room hiện tại hoặc được đánh dấu favorite, chúng sẽ hiện ở đây để kích hoạt nhanh.',
        activate: 'Kích hoạt',
        activating: 'Đang kích hoạt...',
        favorite: 'Yêu thích',
        blocked: 'Bị chặn',
        ready: 'Sẵn sàng',
        neverRun: 'Chưa từng chạy',
        lastActivated: 'Lần chạy gần nhất',
        roomMatchedDevicesSubtitle: 'Thiết bị được match theo room slug/id và metadata của active home.',
        roomSettingsSubtitle: 'Đổi tên / icon / màu cho phòng hiện tại.',
        homeDetailTitle: 'Chi tiết home',
        homeDetailSubtitle: 'Console quản lý home cho member và presence mode.',
        loadHomeFailed: 'Không tải được chi tiết home.',
        loadHomeMembersFailed: 'Không tải được thành viên của home.',
        presenceModeChanged: 'Đã chuyển chế độ hiện diện.',
        inviteMemberSuccess: 'Đã mời thành viên mới.',
        inviteMemberFailed: 'Không mời được thành viên mới.',
        updateMemberFailed: 'Không cập nhật được thành viên.',
        membersLoadedFromApi: 'Đã tải từ API',
        currentMode: 'Chế độ hiện tại',
        currentAccess: 'Quyền hiện tại',
        currentHome: 'Home hiện tại',
        inviteMemberSubtitle: 'Owner/admin có thể mời thành viên mới',
        membersSubtitle: 'Cập nhật role/status trực tiếp cho home đang chọn',
        noMembersYet: 'Chưa có thành viên',
        noMembersYetDesc: 'Home này chưa có member nào trong DB.',
        loadingHomes: 'Đang tải danh sách home...',
        recentActivityTitle: 'Hoạt động gần đây',
        recentActivitySubtitle: 'Log mới nhất của home hiện tại.',
        activityDegraded: 'Hoạt động đang ở chế độ degraded',
        noRecentActivity: 'Chưa có hoạt động gần đây',
        cachedDataBanner: 'Đang hiển thị dữ liệu đã lưu',
        cachedDataHintOffline: 'Mạng đang offline',
        cachedDataHintFallback: 'Đang dùng snapshot gần nhất',
        favoriteScenesTitle: 'Scene ưu tiên',
        favoriteScenesEmpty: 'Chưa có scene ưu tiên cho home hiện tại.',
        loadingFavoriteScenes: 'Đang tải scene ưu tiên...',
        recentSceneActivityTitle: 'Scene gần đây',
        recentSceneActivityEmpty: 'Chưa có scene activity gần đây cho home hiện tại.',
        loadingSceneActivity: 'Đang tải scene activity...',
        presenceModeHelper: 'Presence mode vẫn dùng được ở home hiện tại; scene ưu tiên sẽ hiện ở đây khi backend trả dữ liệu.',
        unavailableShort: 'Tạm chưa sẵn',
        switchingShort: 'Đang đổi...',
        favoriteBadge: '★ Ưu tiên',
        modeLabel: 'Mode',
        sceneLogLabel: 'scene log',
        logsLabel: 'logs'
    },
    en: {
        controlCenter: 'Control center',
        responsiveWorkspace: 'Responsive smart-home workspace',
        ecosystemSynced: 'Ecosystem is synced',
        authRealtimeReady: 'Auth + realtime preserved',
        logout: 'Log out',
        dashboard: 'Dashboard',
        rooms: 'Rooms',
        activity: 'Activity',
        connect: 'Connect',
        settings: 'Settings',
        adminDevices: 'Device management',
        language: 'Language',
        vietnamese: 'Tiếng Việt',
        english: 'English',
        adminOnly: 'Only admins can access this page.',
        save: 'Save',
        cancel: 'Cancel',
        delete: 'Delete',
        confirm: 'Confirm',
        search: 'Search',
        filter: 'Filter',
        all: 'All',
        active: 'Active',
        archived: 'Archived',
        loading: 'Loading',
        refresh: 'Refresh',
        networkError: 'Network error',
        sessionExpired: 'Session expired',
        permissionDenied: 'Permission denied',
        notFound: 'Not found',
        importToApp: 'Import into app',
        importSelected: 'Import selected',
        linked: 'Linked',
        notLinked: 'Not linked',
        xiaomiReady: 'Xiaomi device',
        homeAssistantSource: 'Home Assistant remains the source of truth',
        settingsSubtitle: 'Customize appearance and language for the current user.',
        connectSubtitle: 'Onboarding for device linking through Home Assistant.',
        deviceManagementSubtitle: 'Admin manages metadata, rooms, and HA entity linking.',
        noDevicesYet: 'No matching devices yet.',
        languageSavedLocal: 'Language preference is currently stored in this browser.',
        appearance: 'Appearance',
        deviceLinking: 'Device linking',
        xiaomiFlow: 'Xiaomi flow',
        previewReady: 'Ready for preview',
        roomDevices: 'Room devices',
        noDevicesInRoom: 'No devices in this room',
        editRoom: 'Edit room',
        roomUpdated: 'Room updated',
        newScene: 'New scene',
        editScene: 'Edit scene',
        sceneActions: 'Scene actions',
        addAction: 'Add action',
        removeAction: 'Remove action',
        sceneCreated: 'Scene created',
        sceneUpdated: 'Scene updated',
        entityId: 'Entity ID',
        actionLabel: 'Action',
        actionValue: 'Value',
        homeMembers: 'Home members',
        inviteMember: 'Invite member',
        inviteByEmail: 'Invite by email',
        memberInvited: 'Member invited',
        changeRole: 'Change role',
        disableMember: 'Disable member',
        presenceMode: 'Presence mode',
        home: 'Home',
        away: 'Away',
        night: 'Night',
        vacation: 'Vacation',
        activityFeed: 'Activity feed',
        noActivity: 'No activity yet',
        stateChange: 'State change',
        commandSent: 'Command sent',
        roomFocusSubtitle: 'Track room devices and scenes inside the active home.',
        roomSettings: 'Room settings',
        roomNotFound: 'Room not found',
        roomNotFoundDesc: 'Check the route or return to the dashboard to pick another room.',
        saveRoom: 'Save room',
        roomNoDevices: 'This room has no devices',
        roomNoDevicesDesc: 'Assign room metadata to devices so the room page can render correctly.',
        updateRoomSuccess: 'Room details updated.',
        updateRoomFailed: 'Failed to update room.',
        roomScenes: 'Room scenes',
        noRoomScenes: 'No room scenes yet',
        noRoomScenesDesc: 'When a scene is mapped to this room or marked as favorite, it will appear here for quick activation.',
        activate: 'Activate',
        activating: 'Activating...',
        favorite: 'Favorite',
        blocked: 'Blocked',
        ready: 'Ready',
        neverRun: 'Never run',
        lastActivated: 'Last activated',
        roomMatchedDevicesSubtitle: 'Devices matched by room slug/id and active-home metadata.',
        roomSettingsSubtitle: 'Rename / icon / color for the current room.',
        homeDetailTitle: 'Home detail',
        homeDetailSubtitle: 'Home management console for members and presence mode.',
        loadHomeFailed: 'Failed to load home detail.',
        loadHomeMembersFailed: 'Failed to load home members.',
        presenceModeChanged: 'Presence mode updated.',
        inviteMemberSuccess: 'Member invited.',
        inviteMemberFailed: 'Failed to invite member.',
        updateMemberFailed: 'Failed to update member.',
        membersLoadedFromApi: 'Loaded from API',
        currentMode: 'Current mode',
        currentAccess: 'Current access',
        currentHome: 'Current home',
        inviteMemberSubtitle: 'Owners/admins can invite new members',
        membersSubtitle: 'Update role/status directly for the selected home',
        noMembersYet: 'No members yet',
        noMembersYetDesc: 'This home has no members in the database yet.',
        loadingHomes: 'Loading homes...',
        recentActivityTitle: 'Recent activity',
        recentActivitySubtitle: 'Latest logs from the current home.',
        activityDegraded: 'Activity is degraded',
        noRecentActivity: 'No recent activity',
        cachedDataBanner: 'Showing saved data',
        cachedDataHintOffline: 'Network is offline',
        cachedDataHintFallback: 'Using the latest snapshot',
        favoriteScenesTitle: 'Favorite scenes',
        favoriteScenesEmpty: 'No favorite scenes for the current home yet.',
        loadingFavoriteScenes: 'Loading favorite scenes...',
        recentSceneActivityTitle: 'Recent scene activity',
        recentSceneActivityEmpty: 'No recent scene activity for the current home.',
        loadingSceneActivity: 'Loading scene activity...',
        presenceModeHelper: 'Presence mode still works for the current home; favorite scenes will appear here when backend data is available.',
        unavailableShort: 'Unavailable',
        switchingShort: 'Switching...',
        favoriteBadge: '★ Favorite',
        modeLabel: 'Mode',
        sceneLogLabel: 'scene log',
        logsLabel: 'logs'
    }
};
export function translate(language, key) {
    return translations[language]?.[key] || key;
}
